type UserRolesEntity = { organizationId: string; roles?: string[] };
type ProductRolesEntity = { productId: string; roles?: string[] };

export type RawUserRolesResponse = {
  userRoles?: readonly UserRolesEntity[] | null;
  productRoles?: readonly ProductRolesEntity[] | null;
};

export type ParsedUserRoles = {
  organizationRoles: string[];
  productRoles: string[];
};

export function parseUserRolesResponse(
  rawResponse: RawUserRolesResponse | null | undefined,
  organizationId: string
): ParsedUserRoles {
  const userRolesEntities = Array.isArray(rawResponse?.userRoles) ? rawResponse.userRoles : [];
  const productRolesEntities = Array.isArray(rawResponse?.productRoles)
    ? rawResponse.productRoles
    : [];

  const organizationEntity = userRolesEntities.find(
    (entity) => entity.organizationId === organizationId
  );
  const productEntity = productRolesEntities[0];

  return {
    organizationRoles: organizationEntity?.roles ?? [],
    productRoles: productEntity?.roles ?? [],
  };
}

export default parseUserRolesResponse;
